import React, { useCallback, useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { TextButton, ButtonText } from '@prisjakt/ui/button/variants';
import styled from 'styled-components';

const StyledClearButton = styled(TextButton)`
  display: inline-block;
  color: ${p => p.theme.colors.redio700};
`;

type Props = {
  property?: string;
  disabled?: boolean;
  onClick?: () => void;
  clearFilter: (property?: string) => void;
};

const ClearButton = ({ property, onClick, disabled, clearFilter }: Props) => {
  const { t } = useContext(AppContext);
  const onClickHandler = useCallback(() => {
    if (typeof onClick === 'function') {
      onClick();
    }
    clearFilter(property);
  }, [onClick, clearFilter, property]);
  return (
    <StyledClearButton
      onClick={onClickHandler}
      containerProps={{
        'data-test': 'FeaturedFilterClear',
      }}
      disabled={disabled}
    >
      <ButtonText>{t('filter', 'button.clear-filter')}</ButtonText>
    </StyledClearButton>
  );
};

export default ClearButton;
